export const LOADING = 'LOADING'
export const LOADED = 'LOADED'
export const HAS_ERROR = 'HAS_ERROR'
export const NOT_LOAD = 'NOT_LOAD'